import {
  UPDATE_ARTICLES_LIST,
  UPDATE_ARTICLES_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  searchKey: "",
  status: "",
  sortOrder: 1,
  sortBy: "createdAt",
  articlesList: [],
  isLoading: false,
};

const ArticleReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ARTICLES_LIST: {
      return { ...state, ...action.payload };
    }
    case UPDATE_ARTICLES_LOADING: {
      return { ...state, isLoading: !state.isLoading };
    }
    default:
      return state;
  }
};

export default ArticleReducer;
